import { render, staticRenderFns } from "./topUserReportForms.vue?vue&type=template&id=3c823514&scoped=true"
import script from "./topUserReportForms.vue?vue&type=script&lang=js"
export * from "./topUserReportForms.vue?vue&type=script&lang=js"
import style0 from "./topUserReportForms.vue?vue&type=style&index=0&id=3c823514&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c823514",
  null
  
)

export default component.exports